import { ValueType } from "@/enums/ValueType";
import type { Parameter } from "@/models/Parameter";

export const extraLeenbedragenEnergielabel: Parameter<Record<string, number>> =
	{
		metadata: {
			type: ValueType.Currency,
		},
		values: {
			"2024-01-01": {
				value: {
					"14 A++++ (EP garantie)": 50_000,
					"11 A++++": 40_000,
					"10 A+++": 30_000,
					"01 A++": 20_000,
					"02 A+": 20_000,
					"03 A": 10_000,
					"04 B": 10_000,
					"05 C": 5000,
					"06 D": 5000,
					"07 E": 0,
					"08 F": 0,
					"09 G": 0,
				},
			},
			"2026-01-01": {
				value: {
					"14 A++++ (EP garantie)": 40_000,
					"11 A++++": 30_000,
					"10 A+++": 25_000,
					"01 A++": 20_000,
					"02 A+": 20_000,
					"03 A": 10_000,
					"04 B": 10_000,
					"05 C": 5000,
					"06 D": 5000,
					"07 E": 0,
					"08 F": 0,
					"09 G": 0,
				},
			},
		},
	};
